















































































































































































































































































































import { AxiosError, AxiosResponse } from 'axios';
import _ from 'lodash';
import VueJsonPretty from 'vue-json-pretty';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { between, maxValue, minLength, minValue, required } from 'vuelidate/lib/validators';

import WizardProgress from '@/modules/dap/components/wizard-progress/wizard-progress.vue';
import ActionBar from '@/components/action-bar/action-bar.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';

import { IMarketLevelLimit, IProject, IIndustryProjection } from '@/modules/dap/interfaces';
import { dateService, httpService, numeralService } from '@/services';

import { CONFIG } from '@/config';
import { DAP_ROUTES } from '@/modules/dap/router';
import { Project, IndustryProjection } from '../../models';

@Component({
  components: {
    ActionBar,
    PageLoader,
    WizardProgress,
    VueJsonPretty
  },
  validations: {
    project: {
      name: {
        required,
        minLength: minLength(4)
      },
      initialDateProject: {
        required,
        minValue: minValue(dateService.parseToMoment().startOf('month').toDate())
      },
      qtdMonths: {
        required,
        between: between(1, 76)
      },
      initialHistoryPeriod: {
        required,
        maxValue: maxValue(dateService.parseToMoment().subtract(1, 'month').startOf('month').toDate()),
        biggerThen: (value: Date, field: IProject) => {
          return isFinite(+value) ? +value <= +field.finalHistoryPeriod : true;
        }
      },
      finalHistoryPeriod: {
        required,
        maxValue: maxValue(dateService.parseToMoment().subtract(1, 'month').endOf('month').toDate()),
        lowerThen: (value: Date, field: IProject) => {
          return isFinite(+value) ? +value >= +field.initialHistoryPeriod : true;
        }
      },
      limitPercentInferior: {
        required
      },
      limitPercentSuperior: {
        required
      },
      projectMktShareReferenceDefaults: {
        $each: {
          limitPercentInferior: {
            required
          },
          limitPercentSuperior: {
            required
          }
        }
      }
    }
  }
})
export default class DapWizardCreatePage extends Vue {
  $v: any;

  @Prop() projectId: number;

  public DAP_ROUTES = DAP_ROUTES;
  public parseToMoment = dateService.parseToMoment;
  public parseDateToString = dateService.parseDateToString;
  public parseStringToDate = dateService.parseStringToDate;
  public project: IProject = new Project();
  public referenceMktShareType: Array<any> = [];
  public marketLevelDataSource = [];
  public projectTypeDataSource = [];
  public segmentsDataSource = [];
  public industryProjections = new Array();

  @Watch('project.idMarketShareReferenceType')
  public createsubProjectLimits () {
    this.project.projectMktShareReferenceDefaults = _(this.marketLevelDataSource)
      .filter((d: any) => this.project.idMarketShareReferenceType === d.idType)
      .map((d: any) => ({
        idMarketShareReference: d.id,
        idProject: this.projectId,
        limitPercentSuperior: this.project ? this.project.limitPercentSuperior : 0,
        limitPercentInferior: this.project ? this.project.limitPercentInferior : 0
      }))
      .value();
  }

  public currentMarketLevelDataSource (chunk = 2) {
    return _(this.marketLevelDataSource)
      .filter((d: any) => this.project.idMarketShareReferenceType === d.idType)
      .map((d: any) => ({
        text: d.name,
        value: d.id
      }))
      .chunk(chunk)
      .value();
  }

  public getMarketLevelLimit (id: number): IMarketLevelLimit | undefined {
    return _.find(this.project.projectMktShareReferenceDefaults, (item: IMarketLevelLimit) => item.idMarketShareReference === id);
  }

  public updateMarketLevelLimitInput (event: any, data: any, type: string, index: number) {
    data[type] = (Math.round(numeralService.parseToNumber(event.target.value) * 100) / 100) || 0;
    this.$v.project.projectMktShareReferenceDefaults.$each[index].limitPercentInferior.$touch();
  }

  public updateProjection (event: any) {
    this.project.qtdMonths = this.parseToMoment(event.target.value, 'MM/YYYY').diff(this.project.initialDateProject, 'months') + 1;
    this.$v.project.qtdMonths.$touch();
    this.updateIndustryProjection();
  }

  public updateIndustryProjection() {
    let initialYear = this.parseToMoment(this.project.initialDateProject, 'YYYYY').year();
    let finalYear = this.parseToMoment(this.parseToMoment(this.project.initialDateProject).add(this.project.qtdMonths - 1, 'months'), 'YYYY').year();
    this.industryProjections = [];

    for(let y = initialYear; y <= finalYear; y++) {
      let projections = _.map(this.segmentsDataSource, (d: any) => new IndustryProjection(0, 0, d.value, y, _.filter(this.project.industryProjections, (v: IIndustryProjection) => v.year === y && v.idSegmentGroup === d.value)[0]
          ? _.filter(this.project.industryProjections, (v: IIndustryProjection) => v.year === y && v.idSegmentGroup === d.value)[0].value
          : 0));

      this.industryProjections.push(projections);
    }
  }

  public updateInputNumber (event: any, type) {
    this.project[type] = (Math.round(numeralService.parseToNumber(event.target.value) * 100) / 100) || 0;
    this.$v.project[type].$touch();
  }

  public gotToProjectStores () {
    this.$v.$touch();
    if (this.$v.$error) { return; }

    this.project.industryProjections = _(this.industryProjections).flatten().value();

    const request = this.projectId
      ? httpService.http
        .put(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}`, this.project)
      : httpService.http
        .post(`${CONFIG.URL.NEODASH_API}/api/dap/project`, this.project);

    request
      .then((res: AxiosResponse) => {
        this.$router.push({
          name: DAP_ROUTES.WIZARD_STORES,
          params: { projectId: res.data },
          query: { wizardStep: '1' }
        });
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public goBack () {
    this.$router.push({
      name: this.DAP_ROUTES.PROJECT_EMPTY
    });
  }

  public created () {
    this.loadProject();
  }

  private loadProject () {
    const req = [
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/mktShareReferenceTypes`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/projectTypes`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/segments/aggregate`),
    ];

    if (this.projectId) {
      req.push(httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}`));
    }

    Promise.all(req)
      .then((res: AxiosResponse[]) => {
        if (res[3] && res[3].data) {
          res[3].data.initialDateProject = dateService.parseToMoment(res[3].data.initialDateProject).startOf('month').toDate();
          res[3].data.initialHistoryPeriod = dateService.parseToMoment(res[3].data.initialHistoryPeriod).startOf('month').toDate();
          res[3].data.finalHistoryPeriod = dateService.parseToMoment(res[3].data.finalHistoryPeriod).startOf('month').toDate();

          this.project = _.assign({}, this.project, res[3].data);
          this.segmentsDataSource = res[2].data;
          this.updateIndustryProjection();
        }

        this.referenceMktShareType = res[0].data.map((d: any) => ({
          text: d.name,
          value: d.id
        }));

        this.marketLevelDataSource = _.reduce(res[0].data, (acc, val: any) => {
          return acc.concat(val.marketShareRefences);
        }, []);

        this.projectTypeDataSource = res[1].data;
        this.project.idProjectType = res[1].data[0].value;

        this.segmentsDataSource = res[2].data;

        this.createsubProjectLimits();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }
}
